import { render } from "./ClientDictionaryAssociationModal.vue?vue&type=template&id=12b55d63&scoped=true"
import script from "./ClientDictionaryAssociationModal.vue?vue&type=script&lang=js"
export * from "./ClientDictionaryAssociationModal.vue?vue&type=script&lang=js"

import "./ClientDictionaryAssociationModal.vue?vue&type=style&index=0&id=12b55d63&lang=stylus&scoped=true"
import "./ClientDictionaryAssociationModal.vue?vue&type=style&index=1&id=12b55d63&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b55d63"]])

export default __exports__